import { Box, Chip, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { DashboardMyAppraisal } from '@/api/dashboardApi';
import { SectionCard } from '@/components/common';
import { formatDateShort as formatShortDate } from '@/utils/dateFormatter';
import { AppraisalStatusChip } from './AppraisalStatusChip';

function appraisalLabel(firstName: string, lastName: string): string {
  return `Appraisal \u2013 ${firstName} ${lastName}`;
}

interface MyAppraisalSubsectionProps {
  myAppraisal: DashboardMyAppraisal | null;
}

export function MyAppraisalSubsection({ myAppraisal }: MyAppraisalSubsectionProps) {
  const nextDueDate = myAppraisal?.selfAssessmentDate
    ? formatShortDate(myAppraisal.selfAssessmentDate)
    : null;

  return (
    <SectionCard>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography component="h3" sx={{ typography: { xs: 'h6', md: 'h5' } }}>
          My Appraisal
        </Typography>
        {nextDueDate && nextDueDate !== '-' && (
          <Chip label={`Next due: ${nextDueDate}`} size="small" variant="outlined" />
        )}
      </Box>
      {!myAppraisal ? (
        <Typography variant="body2" color="text.secondary">
          No active appraisal to display.
        </Typography>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'custom.darkTeal', '& th': { color: 'common.white' } }}>
                <TableCell>MY APPRAISAL</TableCell>
                <TableCell>SELF-ASSESSMENT DUE DATE</TableCell>
                <TableCell>STATUS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Link component={RouterLink} to={`/appraisals/${myAppraisal.id}`} underline="hover">
                    {appraisalLabel(myAppraisal.appraiseeFirstName, myAppraisal.appraiseeLastName)}
                  </Link>
                </TableCell>
                <TableCell>
                  {myAppraisal.selfAssessmentDate ? (
                    <Chip label={`Due: ${formatShortDate(myAppraisal.selfAssessmentDate)}`} size="small" variant="outlined" />
                  ) : (
                    '-'
                  )}
                </TableCell>
                <TableCell>
                  <AppraisalStatusChip status={myAppraisal.status} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </SectionCard>
  );
}

export default MyAppraisalSubsection;
